import * as React from 'react';
import { Callout } from 'office-ui-fabric-react/lib/Callout';
import  './Heading.scss';
import HeadingObj from '../../Entity/headingobj';
import {Language} from '../../Utils/Language';
import { DirectionalHint } from 'office-ui-fabric-react/lib/ContextualMenu';

export interface IProps {
  data: HeadingObj;
  changeview: Function;
  language: string;
  options:Array<string>;
  overAllView:  number;
}
export interface MenuState {
  SelectOptions: Array<string>;
  directionalHint?: DirectionalHint;
  directionalHintForRTL?: DirectionalHint;
  useDirectionalHintForRtl?: boolean;
  isBeakVisible?: boolean;
  gapSpace?: number;
  beakWidth?: number;
  edgeFixed?: boolean;
  isCalloutVisible?: boolean;
}
export default class ColHeading extends React.Component<IProps,MenuState, {}> {
  /*state: IProps = {
   
  };*/
  private _menuButtonElement: HTMLElement | null;
  constructor(props: IProps) {
    super(props);
    // let options =MIAPACons.MenuOption.options.slice();

    this.state = { SelectOptions: this.props.options,
                    isCalloutVisible: false,
                    directionalHint: DirectionalHint.topCenter,
                    beakWidth: 16,
              };
  }
  public render() {
    if(this.props.overAllView == -1 && this.props.options.length != this.state.SelectOptions.length) {
      this.setState({SelectOptions: this.props.options,
        isCalloutVisible: false});
    }
    let buttoncss= "selectedmenu ms-Button ms-Button--action ms-Button--command buttonroot";
    let totalitems = this.props.data.Events + this.props.data.Meetings + this.props.data.PlannerTask + this.props.data.SSO + this.props.data.TODOS;
    this.props.data.Total = totalitems;
    /*let selectedoption = Language.GetLanguageValue(this.props.language,'all')+" (" + totalitems + ")";
    if (this.props.data.currentselection > 0) {
      let menuitems = this.GetDropDownmenu();
      let props = menuitems[this.props.data.currentselection].type;
      selectedoption = menuitems[this.props.data.currentselection].display  + ' (' + this.props.data[props] + ')';
    }*/
    const { isCalloutVisible, beakWidth } = this.state;
    return (
          <div className="mipaheading">
          <div className="component">
                <span>{Language.GetLanguageValue(this.props.language,this.props.data.title)} </span>
                  
                  {this.props.overAllView !=7?
                  <button style={{display:'none'}} className={buttoncss} type="button" ref={menuButton => (this._menuButtonElement = menuButton)} onClick={this._onMenuClicked}>
                                  <div>
                                          <span>{Language.GetLanguageValue(this.props.language,'options')} </span>
                                          <i className="ms-Icon ms-Icon--ChevronDown x-hidden-focus" />
                                  </div>
                          
                          </button>:null}
                          {isCalloutVisible ? (
                    <Callout

                      className="ms-Callout-callout"
                      onDismiss={this._onCalloutDismiss}
                      target={this._menuButtonElement}
                      directionalHint={DirectionalHint.topAutoEdge}
                      coverTarget={false}
                      isBeakVisible={true}
                      gapSpace={0}
                      beakWidth={beakWidth}
                    >
                      <div className='detailcallout1'>

                        <div className="ms-Callout-inner" style={{ padding: '10px' }}>
                          <div className="ms-Callout-content ms-Grid menugrid">
                            {this.GetDropDownmenu().map((element, keyIndex)=> {
                                return (
                                    <div className="ms-Grid-row" key={"Calviewmenu_"+keyIndex}>
                                  {this.PreparemenuItems(element)}
                                </div> 
                                );                                                    
                            })}
                          </div>
                        </div>
                      </div>
                    </Callout>
                  ) : null}
                </div>
          </div>
    );
  }
  public PreparemenuItems = (element) => {
    let activehtml=<i style={{opacity:0}} className="ms-Icon ms-Icon--Accept" />;
    if(this.state.SelectOptions.indexOf(element.type) >= 0) {
        activehtml=<i className="ms-Icon ms-Icon--Accept" />;
    }
    let displayName=element.type=='Switch'?element.display:element.display+(this.props.data[element.type]?' ('+this.props.data[element.type]+')':' (0)');
    let menuitemoption=(
        <div 
            className="ms-Grid-col ms-sm12" 
            onClick={() => { 
                if(element.type == 'Switch') {
                  this.props.changeview(this.props.data.colNo, null); 
                } else {
                  let prevoptions = this.state.SelectOptions;
                  let index = prevoptions.indexOf(element.type);
                  if (index >= 0) {
                      prevoptions.splice(index, 1);
                  } else {
                      prevoptions.push(element.type);
                  }
                  this.setState({ SelectOptions: prevoptions });
                  this.props.changeview(this.props.data.colNo, prevoptions);  
                }
                  
              }}
          >
            {activehtml} {displayName}
        </div>
    );
   return menuitemoption;
}
  /*public PreparemenuItems(): IContextualMenuItem[] {
    let menus = [];
    let keyIndex = 0;
    let menuitems = this.GetDropDownmenu();
    menuitems.forEach((element) => {
      let displayName = element.display;
      if (keyIndex == 0) {
        displayName += ' (' + this.props.data.Total + ')';
      }
      else if (keyIndex < 6) {
        let props = menuitems[keyIndex].type;
        displayName += ' (' + this.props.data[props] + ')';
      }
      let menu = {
        key: 'heading_' + this.props.data.colNo + "_" + keyIndex,
        name: displayName,
        iconProps: {
          className: this.props.data.currentselection == keyIndex ? 'ms-Icon ms-Icon--Accept' : ''
        },
        onClick: (evt, item) => {
          let menuindex = parseInt(item.key.replace('heading_' + this.props.data.colNo + "_", ''));
          this.props.changeview(this.props.data.colNo, menuindex);
        }
      };
      keyIndex++;
      menus.push(menu);
    });
    return menus;
  }*/
  public GetDropDownmenu(): Array<any> {
    let items = [
      /*{ type: "All", display:Language.GetLanguageValue(this.props.language,'all')},*/
    { type: "Meetings", display:Language.GetLanguageValue(this.props.language,'meetingreport') },
    { type: "SSO", display:Language.GetLanguageValue(this.props.language,'opportunity') },
    { type: "PlannerTask", display:Language.GetLanguageValue(this.props.language,'plannertask')},
    { type: "Events", display:Language.GetLanguageValue(this.props.language,'meeting')},
    { type: "TODOS", display:Language.GetLanguageValue(this.props.language,'todo')},
    { type: "FlaggedEmail", display:Language.GetLanguageValue(this.props.language,'FlagedEmail')},
    { type: "MSList", display:Language.GetLanguageValue(this.props.language,'MSList')}];
    /*if (this.props.data.colNo != 0) {
      items.push({ type: "Switch", display: Language.GetLanguageValue(this.props.language,'switchcallview')});
    }*/
    return items;
  }
  private _onCalloutDismiss = (): void => {
       
    this.setState({
      isCalloutVisible: false
    });
  }

  private _onMenuClicked = (): void => {    
    this.setState({
      isCalloutVisible: !this.state.isCalloutVisible
    });
  }

}
